import { Button, Grid2, MenuItem, Select, Typography } from "@mui/material"
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { GoogleMap, useJsApiLoader, DirectionsRenderer, Polygon, DrawingManager } from '@react-google-maps/api';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import constants from '../../constant.js';
import TokenError from "../tokenError";
import { useNavigate } from "react-router-dom";

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const Geofence = () => {
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [geofence, setGeofence] = useState(cities[0].geofence[0]);
    // const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [isPolygonVisible, setIsPolygonVisible] = useState(true);
    const [drawingMode, setDrawingMode] = useState(false);  // State to track drawing mode
    const [polygonPath, setPolygonPath] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [mapInstance, setMapInstance] = useState(null);
    const [bound, setBound] = useState(false);

    const [center,setCenter] = useState(null);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (mapInstance && geofence && geofence.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            geofence.forEach((point) =>
                bounds.extend({ lat: Number(point.x), lng: Number(point.y) })
            );
            mapInstance.fitBounds(bounds);
        }
    }, [bound]);

    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: 'AIzaSyB9PP9WVCovkYUaRZu3S-ts5sDExixgLsg',
    //     libraries: ['drawing'], 
    // })
    // const loaderOptions = useMemo(() => ({
    //     version: "weekly",
    //     apiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES, // Use the static LIBRARIES constant
    //     language: "en",
    //     region: "US",
    // }), []);
    const loaderOptions = {
        id: 'google-map-script',
        googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
        libraries: LIBRARIES,
    }
    
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    const containerStyle = {
        width: '100%',
        height: '480px',
      };
    
    useEffect(() => {
        const geofencePoints = Array.isArray(geofence[0]) ? geofence[0] : geofence;
    
        const isValid = geofencePoints.every(
            (point) => point && !isNaN(Number(point.x)) && !isNaN(Number(point.y))
        );
    
        if (isValid) {
            const c = {
                lat: geofencePoints.reduce((sum, point) => sum + Number(point.x), 0) / geofencePoints.length,
                lng: geofencePoints.reduce((sum, point) => sum + Number(point.y), 0) / geofencePoints.length,
            };
            setCenter(c);
        } else {
            console.error('Invalid geofence data:', geofencePoints);
            setCenter({ lat: 0, lng: 0 }); // Fallback to default
        }
    }, [geofence]);
    
    useEffect(() => {
        console.log('Updated center:', center);
    }, [center]);

    const drawingManagerRef = useRef(null);

    const onLoad = React.useCallback(function callback(map) {
        // const bounds = new window.google.maps.LatLngBounds()
        // map.fitBounds(bounds)
        setMapInstance(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMapInstance(null);
        console.log('unmounting');
    }, []);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        // setGeofence(city ? city.geofence : null);
    }

    const handlePolygonClick = () => {
        // Toggle selection
        setSelectedPolygon(selectedPolygon ? null : geofence[0]);
    };

    const handleDeletePolygon = () => {
        // Delete the selected polygon
        console.log('selected polugon', selectedPolygon);
        setIsPolygonVisible(false);
        setSelectedPolygon(null);  // Reset the selection
    };

    const onLoadDrawingManager = (drawingManager) => {
        drawingManagerRef.current = drawingManager;
    };

    const onPolygonComplete = (polygon) => {
        const path = polygon.getPath().getArray();
        const coordinates = path.map(latLng => ({
            lat: latLng.lat(),
            lng: latLng.lng(),
        }));
        setPolygonPath(coordinates);
        setDrawingMode(false);  // Disable drawing mode after polygon is drawn
    };

    const handleDrawPolygon = () => {
        if (!isLoaded || !window.google) {
            console.error("Google Maps API not loaded yet");
            return;
        }
        setDrawingMode(true);
        if (drawingManagerRef.current) {
            drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
        }
    };

    const handleUpdatePolygon = async() => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const url = operationsUrl + '/city/update_city_geofence';
            const body = {
                token: token,
                geofence: polygonPath,
                city_id: cityFilter,
            };
            const response =  await makePostRequestToUrl(url, body);

            if (response.flag==200) {
                fetchPolygon();
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error');
            // setError('An error occurred. Please try again later.');
        }
        
    }

    const fetchPolygon = async() => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const url = serverUrl + '/city/geofence';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const fetchedGeofence = response.data.city_info[0].geofence;

                if (fetchedGeofence) {
                    setGeofence(fetchedGeofence);  // Update state with new geofence
                    setIsPolygonVisible(true);
                }
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=>{
        fetchPolygon();
    },[cityFilter]);

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            {/* <Navbar/>
            <div className='App'>
                <Sidemenu/>
                <div className='content'> */}
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Geofence</Typography>
                    <Grid2 item container>
                        <Grid2 item sx={{marginTop:'2%'}}>
                            <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                            style={{width: '220px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_name} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>

                        <Grid2 item sx={{marginTop:'1%', marginLeft:'2%'}}>
                            {selectedPolygon && (
                                <Button
                                    variant="contained"
                                    color="danger"
                                    onClick={handleDeletePolygon}
                                    style={{ marginTop: '20px' }}
                                >
                                    Delete Geofence
                                </Button>
                            )}
                        </Grid2>

                        <Grid2 item sx={{marginTop:'1%', marginLeft:'2%'}}>
                            {/* {selectedPolygon && ( */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleDrawPolygon}
                                    style={{ marginTop: '20px' }}
                                >
                                    Draw Geofence
                                </Button>
                            {/* )} */}
                        </Grid2>

                        <Grid2 item sx={{marginTop:'1%', marginLeft:'2%'}}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleUpdatePolygon}
                                style={{ marginTop: '20px' }}
                            >
                                Update Geofence
                            </Button>
                        </Grid2>
                    </Grid2>

                    <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={8} onLoad={onLoad} onIdle={()=> { setBound(true)}} onUnmount={onUnmount}>
                                
                                {drawingMode && (
                                    <DrawingManager
                                        onLoad={onLoadDrawingManager}
                                        onPolygonComplete={onPolygonComplete}
                                        drawingMode={window.google.maps.drawing.OverlayType.POLYGON}
                                    />
                                )}

                                {isPolygonVisible && geofence && geofence[0].length > 0 && (
                                    <Polygon
                                        paths={geofence[0].map((point) => ({
                                            lat: Number(point.x), // Convert x to lat
                                            lng: Number(point.y)  // Convert y to lng
                                        }))
                                        .filter((point) => !isNaN(point.lat) && !isNaN(point.lng) && isFinite(point.lat) && isFinite(point.lng))
                                    } 
                                        options={{
                                            fillColor: "rgba(255, 0, 0, 0.3)", // Semi-transparent fill color
                                            fillOpacity: 0.4,
                                            strokeColor: "red",
                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                        }}
                                        onClick={handlePolygonClick} 
                                    />
                                )}
                                
                            </GoogleMap>
                            
                        ): (<></>)}
                    </Grid2>
                {/* </div>
            </div> */}
       </div>
    )
}

export default Geofence;